import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchAllStudies = async () => {
  return await api.get(`/study/all`);
};

export const useGetAllStudiesQuery = () => {
  return useQuery({
    queryKey: ["get-all-studies"],
    queryFn: () => fetchAllStudies(),
    select: (data) => {
      return data.data.data;
    },
    keepPreviousData: true,
  });
};
